import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import {
    LandownerDetailsInterface,
    UserInterface,
  } from "@/types/UserInterface";
  import { getFirstLastName } from "@/helpers/user";
  import { useRoleByRouteInAdmin } from "@/features/useRoleByRouteInAdmin";
  import { UserRoles } from "@/enums/UserRoles";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLandownerDetailsUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const { roleByRoute } = useRoleByRouteInAdmin();
  const userId = router.currentRoute.value.params.userId;
  const user = ref<UserInterface | null>(null);
  const form = reactive<Partial<LandownerDetailsInterface>>({
    abnAcn: "",
    companyName: "",
    companyAddress: "",
    chargebeeCustomerId: "",
  });
  const rules = computed(() => {
    if (roleByRoute.value === UserRoles.LAWYER) {
      return {
        companyName: { required },
      };
    } else {
      return {
        abnAcn: { required },
        companyName: { required },
        companyAddress: { required },
      };
    }
  });
  const v$ = useVuelidate(rules, form);

  onMounted(() => {
    store.dispatch("user/getUser", userId).then((res) => {
      user.value = res.data;
      form.abnAcn = res.data.detailsId.abnAcn;
      form.companyName = res.data.detailsId.companyName;
      form.companyAddress = res.data.detailsId.companyAddress;
      form.chargebeeCustomerId = res.data.detailsId.chargebeeCustomerId;
    });
  });

  const updateUser = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) {
      return;
    }

    const data = {
      id: user.value.detailsId._id,
      data: form,
    };
    const actionName =
      roleByRoute.value === UserRoles.LAWYER
        ? "user/updateLawyerDetails"
        : "user/updateLandownerDetails";

    store.dispatch(actionName, data).then(() => {
      router.push({
        name:
          roleByRoute.value === UserRoles.LAWYER ? "AdminLawyer" : "AdminUser",
        params: { userId },
      });
    });
  };

const __returned__ = { roleByRoute, userId, user, form, rules, v$, updateUser, computed, onMounted, reactive, ref, get useVuelidate() { return useVuelidate }, get required() { return required }, get store() { return store }, get router() { return router }, get LandownerDetailsInterface() { return LandownerDetailsInterface }, get UserInterface() { return UserInterface }, get getFirstLastName() { return getFirstLastName }, get useRoleByRouteInAdmin() { return useRoleByRouteInAdmin }, get UserRoles() { return UserRoles } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})